import { Box, Divider, ListItem, ListItemText } from '@material-ui/core';

const SubscriptionList = ({ classes, hasDiscount, name, value }) => (
  <Box>
    <ListItem className={classes.listItemContainer}>
      <ListItemText
        style={{
          fontFamily: 'TitilliumWeb-Regular',
          WebkitFontSmoothing: 'auto',
        }}
        primary={name}
        className={classes.listItemNode}
      />
      <ListItemText
        style={{
          fontWeight: 700,
          fontFamily: 'titillium-semibold',
          WebkitFontSmoothing: 'auto',
        }}
        className={classes.listItemNode}
        disableTypography
        primary={
          hasDiscount ? (
            <>
              <strike className={classes.discountAmount}>{hasDiscount}</strike>{' '}
              {value}
            </>
          ) : (
            value
          )
        }
      />
    </ListItem>
    <Divider />
  </Box>
);

export default SubscriptionList;
